import React from "react";
import { Star, MapPin, Quote } from "lucide-react";

const TESTIMONIALS = [
    {
        quote: "Ab meri dukaan ka bhi ek professional online address hai.",
        detail: "Pehle customers ko location aur products ke baare mein baar-baar WhatsApp par batana padta tha. Ab main bas apni website ka link share kar deta hoon, aur business mein sales bhi zyada ho rahi hai website banane ke baad.",
        name: "Rohit Sharma",
        business: "Sharma Footwear",
        location: "Jammu, J&K",
    },
    {
        quote: "It's very easy to create a website for your business with this platform — must try, everyone! 🩷🩷",
        detail: "Services, timings, contact number aur location sab ek page par hai. Visiting card par QR code lagana bhi easy ho gaya.",
        name: "Pooja Verma",
        business: "Pooja Beauty Studio",
        location: "Jaipur, Rajasthan",
    },
    {
        quote: "I never thought I could create a website for my work without a developer, but this platform made it possible. Thank you so much 😁😁",
        detail: "Mujhe complicated website nahi chahiye thi. Bas ek professional page chahiye tha jise main customers ko WhatsApp aur Instagram par bhej sakun — and this platform gave me exactly what I want.",
        name: "Aman Gupta",
        business: "Gupta Home Decor",
        location: "Lucknow, Uttar Pradesh",
    },
    {
        quote: "Customers ko menu aur contact details bhejna ab kaafi easy hai.",
        detail: "Pehle mujhe photos aur details alag-alag bhejni padti thi. Ab ek link share karna enough hai.",
        name: "Neha Kapoor",
        business: "The Daily Bake",
        location: "Chandigarh, Punjab",
    },
];

const initials = (name) =>
    name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const Testimonials = () => {
    return (
        <section className="relative px-4 sm:px-6 py-16" data-testid="testimonials-section">
            <div className="max-w-6xl mx-auto">
                <div className="text-center max-w-2xl mx-auto">
                    <div className="inline-flex items-center gap-2 rounded-full glass px-4 py-1.5 text-[13px] text-muted-foreground">
                        <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" /> Loved by local businesses
                    </div>
                    <h2 className="font-heading mt-6 text-3xl sm:text-4xl font-semibold tracking-tight">
                        What business owners say
                    </h2>
                    <p className="mt-3 text-muted-foreground">Real stores, real websites, real results.</p>
                </div>

                <div className="grid sm:grid-cols-2 gap-5 mt-10 stagger">
                    {TESTIMONIALS.map((tm, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="relative glass rounded-3xl p-7 hover-lift flex flex-col"
                        >
                            <Quote className="absolute top-6 right-6 w-8 h-8 text-accent/15" />
                            <div className="flex items-center gap-1" aria-label="5 out of 5 stars">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
                                ))}
                            </div>
                            <blockquote className="mt-4 font-heading text-lg font-semibold leading-snug text-foreground">
                                “{tm.quote}”
                            </blockquote>
                            <p className="mt-3 text-sm text-muted-foreground leading-relaxed flex-1">{tm.detail}</p>
                            <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t border-border/60">
                                <div className="w-11 h-11 rounded-full bg-accent text-white flex items-center justify-center font-heading font-semibold text-sm shrink-0">
                                    {initials(tm.name)}
                                </div>
                                <div className="min-w-0">
                                    <div className="text-sm font-semibold">{tm.name}</div>
                                    <div className="text-xs text-muted-foreground flex items-center gap-1 flex-wrap">
                                        <span>{tm.business}</span>
                                        <span className="opacity-50">·</span>
                                        <span className="inline-flex items-center gap-0.5"><MapPin className="w-3 h-3" /> {tm.location}</span>
                                    </div>
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
